import { useEffect, useState } from "react";
import {
  CheckBoxActiveIcon,
  CheckBoxInActiveIcon,
  CopyIcon,
  GoToLogo,
  GraphProgressionArrow,
  RadioBoxActiveIcon,
  RadioBoxInActiveIcon,
  TickIcon
} from "../../Assets/assets";
import {
  capitalizeFirstLetter,
  openInNewTab
} from "../../Utils/Constants/Constants";
import { Fields } from "../Previews/WorkforcePreview";

export const InfoCard = (props) => {
  return (
    <>
      <div
        style={{
          minWidth: "400px",
          width: "calc(100% / 3 - 20px)"
        }}
        className="background-color-tertiaryColor1 padding-larger display-flex flex-align-items-center"
      >
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between">
            <div className="font-size-medium font-color-tertiaryColor6">
              {props.data.title}
            </div>
          </div>
          <div className="display-flex padding-top-default flex-align-items-center">
            <div
              style={{
                fontSize: "24px"
              }}
              className="padding-right-large font-color-tertiaryColor"
            >
              {props.data.value}
            </div>
            {props.data.progression ? (
              <div className="display-flex">
                <div
                  style={{
                    height: "16px",
                    width: "16px"
                  }}
                  className="margin-right-default "
                >
                  <GraphProgressionArrow
                    color={
                      props.data.progression === "positive"
                        ? "var(--secondaryColor)"
                        : "Red"
                    }
                  />
                </div>
                <div
                  style={{
                    color:
                      props.data.progression === "positive"
                        ? "var(--secondaryColor)"
                        : "Red"
                  }}
                >
                  {props.data.difference} %
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="">{props.data.icon}</div>
      </div>
    </>
  );
};

export const GraphCard = (props) => {
  return (
    <div
      style={{
        minWidth: "400px",
        minHeight: "265px",
        width: "calc(100% / 3 - 20px)",
        height: "calc(50% / 2 - 20px)",
        background:
          props.isLoading || props.comingSoon
            ? "transparent"
            : "var(--tertiaryColor1)",
        ...(props.comingSoon || props.isLoading
          ? { border: "dashed 1px var(--tertiaryColor3)" }
          : {})
      }}
      className={` padding-larger padding-larger flex-justify-content-space-between flex-direction-column position-relative`}
      data-cy={`${props.comingSoon ? "COMING SOON" : props.title}${
        props.isLoading ? "-loading" : ""
      }`}
    >
      {!props.isLoading ? (
        <>
          <div className="font-size-medium font-color-tertiaryColor6 text-align-center">
            {props.comingSoon ? "COMING SOON" : props.title}
          </div>

          {props.customData ? (
            <div className="display-flex flex-align-items-center flex-justify-content-space-between">
              {props.customData}
            </div>
          ) : (
            <div className="display-flex flex-align-items-center flex-justify-content-space-between">
              <div className="display-flex flex-align-items-center flex-justify-content-center flex-direction-column position-relative">
                <div
                  style={{
                    width:
                      props.type === "line" || props.type === "bar"
                        ? "105%"
                        : "200px",
                    height:
                      props.type === "line" || props.type === "bar"
                        ? "180px"
                        : "180px",
                    filter: props.comingSoon ? "blur(16px)" : "none",
                    pointerEvents: props.comingSoon ? "none" : "auto"
                  }}
                >
                  {props.graph}
                </div>
              </div>

              {props.legend && <div>{props.legend}</div>}
            </div>
          )}
        </>
      ) : (
        <>
          <div
            className={
              props.theme === "dark" ? "shimmer-dark" : "shimmer-light"
            }
            style={{ width: "100%", height: "40px" }}
          />
          <div
            className={
              props.theme === "dark" ? "shimmer-dark" : "shimmer-light"
            }
            style={{ width: "100%", height: "154px", marginTop: "24px" }}
          />
        </>
      )}
    </div>
  );
};

export const LegendCard = (props) => {
  return (
    <div className="display-flex flex-align-items-center flex-justify-content-center padding-bottom-smaller">
      {props.data?.labels[props.index] && (
        <div
          style={{
            height: "10px",
            width: "10px",
            backgroundColor: props.color,
            borderRadius: "100%"
          }}
        />
      )}
      <div
        className={`padding-left-default font-color-tertiaryColor6  font-size-small white-space-no-wrap ${
          props.data?.datasets[0]?.backgroundColor.length - 1 !== props.index
            ? "padding-right-large"
            : ""
        }`}
        style={{
          width: "160px",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
        title={props.data?.labels[props.index]?.toLocaleLowerCase()}
      >
        {props.units || ""} {props.units ? "-" : ""}
        {capitalizeFirstLetter(
          props.data?.labels[props.index]?.toLocaleLowerCase()
        )}
        {props.count && typeof props.data.defaultValue.totalPresent === "string"
          ? ` - ${props.data.defaultValue.totalPresent}`
          : ""}
      </div>
    </div>
  );
};

export const SelectionRadioCard = (props) => {
  return (
    <div
      style={{
        border: "solid 1px var(--tertiaryColor3)"
      }}
      className="padding-large cursor-pointer"
      data-cy={`${props.data.title?.toUpperCase()}-SELECTION-CARD`}
    >
      <div className="display-flex">
        <div className="padding-top-small">
          {props.selected ? (
            <RadioBoxActiveIcon color="var(--secondaryColor)" />
          ) : (
            <RadioBoxInActiveIcon />
          )}
        </div>
        <div className="padding-left-default">
          <div className="font-color-tertiaryColor">{props.data.title}</div>
          <div className="padding-top-default font-size-small font-color-tertiaryColor6">
            {props.data.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export const SelectionSquareCard = (props) => {
  return (
    <div
      style={{
        border: "solid 1px var(--tertiaryColor3)"
      }}
      className="padding-large cursor-pointer"
      data-cy={`${props.data.title?.toUpperCase()}-SELECTION-CARD`}
    >
      <div className="display-flex">
        <div className="padding-top-small">
          {props.selected ? (
            <CheckBoxActiveIcon color="var(--secondaryColor)" />
          ) : (
            <CheckBoxInActiveIcon />
          )}
        </div>
        <div className="padding-left-default">
          <div className="font-color-tertiaryColor">{props.data.title}</div>
          <div className="padding-top-default font-size-small font-color-tertiaryColor6">
            {props.data.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export const SelectionCard = (props) => {
  return (
    <div
      className="padding-default display-flex flex-justify-content-space-between flex-align-items-center"
      style={{
        border: "0.5px solid #6E6E6E",
        backgroundColor: "var(--tertiaryColor8)"
      }}
      data-cy={`SELECTED-${props.title?.toUpperCase()}`}
    >
      <div className="display-flex flex-align-items-center flex-justify-content-center">
        <div className="font-size-small padding-right-default font-color-tertiaryColor6">
          {props.title}
        </div>
        <div className="font-color-tertiaryColor padding-bottom-smaller text-capitalize">
          {props.value}
        </div>
      </div>
      {props.disabled ? (
        <></>
      ) : (
        <div
          className="font-color-tertiaryColor cursor-pointer"
          onClick={props.changeOnClick}
          data-cy={`CHANGE-${props.title?.toUpperCase()}-BUTTON`}
        >
          Change
        </div>
      )}
    </div>
  );
};

export function CaptureItem({ fileSrc, fields, showPicture = true }) {
  return (
    <div className="display-flex inherit-parent-width font-color-tertiaryColor margin-bottom-large">
      {showPicture && (
        <div
          className="padding-right-large cursor-pointer"
          style={{ height: "60px" }}
        >
          {fileSrc ? (
            <img
              loading="lazy"
              style={{ width: "60px", height: "60px" }}
              src={fileSrc}
              alt="captureImage"
              onClick={() => openInNewTab(fileSrc)}
            />
          ) : (
            <div
              style={{ width: "60px", height: "60px" }}
              className={`${
                getComputedStyle(document.documentElement).getPropertyValue(
                  "--primaryColor"
                ) === "#0E0E0E"
                  ? "shimmer-dark"
                  : "shimmer-light"
              } padding-large"`}
            />
          )}
        </div>
      )}

      <div className="display-flex inherit-parent-width flex-direction-column">
        {fields.map(({ key, value }) => (
          <Fields
            key={key}
            title={key}
            data={value}
            dataCy={`preview-${key.toLowerCase().replace(/\s+/g, "-")}`}
          />
        ))}
      </div>
    </div>
  );
}

export const ShareCard = (props) => {
  const [showTick, setShowTick] = useState(false);
  const url =
    props.data.key === "admin"
      ? `${props.data.url}/locations/complaints/${props.complaintId}`
      : `${props.data.url}/complaints/${props.complaintId}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showTick) {
        setShowTick(false);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [showTick]);

  return (
    <div
      className="padding-vertical-small"
      data-cy={`${props.data.key}-SHARE-CARD`}
    >
      <div className="font-color-tertiaryColor6 padding-bottom-small">
        {props.data.title}
      </div>
      <div className="flex-justify-content-space-between">
        <div className="text-overflow-ellipsis" style={{ fontWeight: 500 }}>
          {url}
        </div>
        <div style={{ gap: "16px", display: "flex", marginLeft: "16px" }}>
          {showTick ? (
            <div>
              <TickIcon height={16} width={16} color="var(--tertiaryColor6)" />
            </div>
          ) : (
            <div
              className="cursor-pointer"
              onClick={() => {
                setShowTick(true);
                navigator.clipboard.writeText(url);
              }}
            >
              <CopyIcon />
            </div>
          )}

          <div
            className="cursor-pointer"
            onClick={() => openInNewTab(url)}
            title="Open link"
          >
            <GoToLogo />
          </div>
        </div>
      </div>
    </div>
  );
};
